import { useTranslation } from "react-i18next";
import MapPinCircle from "@/assets/icons/MapPinCircle";

export interface ShippingAddress {
  street: string;
  number: string;
  complement?: string | null;
  neighborhood: string;
  city: string;
  state: string;
  zipcode: string;
  country?: string;
}

interface ShippingAddressSectionProps {
  address: ShippingAddress;
}

export default function ShippingAddressSection({ address }: ShippingAddressSectionProps) {
  const { t } = useTranslation(["orders"]);

  return (
    <div className="md:space-y-6 space-y-4">
      <div className="flex items-center gap-1">
        <MapPinCircle />
        <h2 className="text-colorText font-semibold">
          {t("orders:shipping_address.title")}
        </h2>
      </div>

      <section className="grid gap-6 grid-cols-1 lg:grid-cols-2 text-sm">
        <article className="lg:col-span-2">
          <p className="text-muted text-sm">
            {t("orders:shipping_address.street")}
          </p>
          <span className="text-colorText text-sm">
            {address.street}, {address.number}
            {address.complement && ` - ${address.complement}`}
          </span>
        </article>

        <article>
          <p className="text-muted text-sm">
            {t("orders:shipping_address.neighborhood")}
          </p>
          <span className="text-colorText text-sm">{address.neighborhood}</span>
        </article>

        <article>
          <p className="text-muted text-sm">
            {t("orders:shipping_address.city")}
          </p>
          <span className="text-colorText text-sm">{address.city}</span>
        </article>

        <article>
          <p className="text-muted text-sm">
            {t("orders:shipping_address.state")}
          </p>
          <span className="text-colorText text-sm">{address.state}</span>
        </article>

        <article>
          <p className="text-muted text-sm">
            {t("orders:shipping_address.zipcode")}
          </p>
          <span className="text-colorText text-sm">{address.zipcode}</span>
        </article>

        {address.country && (
          <article>
            <p className="text-muted text-sm">
              {t("orders:shipping_address.country")}
            </p>
            <span className="text-colorText text-sm">{address.country}</span>
          </article>
        )}
      </section>
    </div>
  );
}
